export default {
  lightGrey: '#cecece',
  lightGreyTwo: '#f6f6f2',
  lightGreyThree: '#f9f9f6',
  warmGrey: '#919191',
  grey: '#d1d1d1',
  greyTwo: '#6b6b6b',
  brownishGrey: '#666666',
  greyish: '#bdbab4',
  blackThree: '#333333',
  offWhite: '#f6f6f3',
  grayFour: '#EFEFE9',
  grayFive: '#b9b9b9',
  graySix: '#7c7c7c',
  graySeven: '#c9c4b6',
  grayEight: '#E8E8E5',
  grayNine: '#F8F8F8',
  borderSelect: '#979797',
  darkGray: '#4A4A4A',
  darkerGray: '#737373',
  gray: '#797979',
  footerText: '#424039',
  footerLogo: '#706E6B',
  checkbox: '#9D9D9D',
  textButton: '#D64000',
  textButtonDisable: '#6C6C6C',
  textButtonSecondary: '#222222',
  backgroundButton: '#C83C00',
  backgroundButton2: '#676767',
  brightOrangeTwo: '#ee6300',
  tangerine: '#ff9900',
  brightOrangeThree: '#ff6927',
  squash: '#f3971b',
  freemium: '#F37C21',
  greyishBrown: '#dbd7d1',
  backgroundBody: '#DAD6D0',
  slider: '#FC7C00',
  checkboxOrange: '#F8AE37',
  iconOrange: '#f7540f',
  warmPurple: '#b22e85',
  waterBlue: '#1b99da',
  journalsBlue: '#2bbaf7',
  paleRed: '#d42727',
  nastyGreen: '#6ea945'
};



// WEBPACK FOOTER //
// ./src/theme/search/colors.js